module.exports = __webpack_public_path__ + "img/logo.4e9eca83.png";